export default __webpack_public_path__ + "static/10-0f712f4887bb5037fe9e96571d9fb63d.webp";